import api from "../../../utilidades/interceptor";
import Swal from "sweetalert2";
const urlApi = process.env.REACT_APP_API_KEY

export const getClientsCatalog = async () => {
    try {

        const result = await api.get(`${urlApi}/comercial/getClientsCatalog`);
        return result.data;

    } catch (error) {
        console.log("error", error);
    }
};

export const getClientData = async (id) => {
    try {
        const result = await api.get(`${urlApi}/comercial/getClientData?id=${id}`);
        return result.data;

    } catch (error) {
        console.log("error", error);
    }
};

export const getOptions = async () => {
    try {
        const result = await api.get(`${urlApi}/comercial/getOptions`);
        return result.data;

    } catch (error) {
        console.log("error", error);
    }
};

export const updateClient = async (formData) => {
    try {
        const res = await api.post(`${urlApi}/comercial/updateClient`, formData, {
            headers: {"Content-Type": "multipart/form-data"},
        });
        return res.data
    } catch (error) {
        console.error("Error al subir archivo", error);
        throw error;
    }
};

export const addContact = async (contact) => {
    try {
        const res = await api.post(`${urlApi}/comercial/addContact`, contact);
        return res.data
    } catch (error) {
        console.error("Error al subir archivo", error);
        throw error;
    }
};

export const deleteContact = async (contact) => {
    try {
        const res = await api.post(`${urlApi}/comercial/deleteContact`, contact);
        return res.data
    } catch (error) {
        console.error("Error al subir archivo", error);
        throw error;
    }
};
